var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedItemIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.444444,
    y: 0.444444,
    width: 16.1111,
    height: 16.1111,
    rx: 4,
    fill: "#666AF6",
    stroke: "#666AF6",
    strokeWidth: 0.888889
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0187 6.1743L7.54606 11.647C7.41692 11.7758 7.24189 11.8482 7.05945 11.8482C6.87694 11.8482 6.70198 11.7758 6.57277 11.647L3.97693 9.05095C3.80452 8.87686 3.73777 8.62417 3.80163 8.38755C3.86542 8.15102 4.05022 7.96622 4.28682 7.90236C4.52336 7.83856 4.77605 7.90532 4.95022 8.07773L6.91794 10.0456C6.99607 10.1238 7.12279 10.1238 7.20092 10.0456L12.0449 5.2016C12.1738 5.07145 12.3492 4.99804 12.5323 4.99756C12.7155 4.99709 12.8912 5.06963 13.0207 5.19911C13.1502 5.32858 13.2228 5.50436 13.2223 5.68754C13.2218 5.87065 13.1484 6.04608 13.0182 6.17489L13.0187 6.1743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedItemIcon);
export default __webpack_public_path__ + "static/media/SelectedItemIcon.34703bd4bd0db945c4ff8cec537171e3.svg";
export { ForwardRef as ReactComponent };